<div class="our-main-partners">
  <div class="container">
    <div class="our-main-partners-container">
      <h2 class="title">{{ "shop-with-our-partners" | translate }}</h2>
      <p class="sub-title">
        {{ "our-partners-desc" | translate }}
      </p>
      <div class="main-tabs">
        <div class="tabcontent">
          <ul class="partners-items">
            <li
              *ngFor="
                let store of partners
                  | paginate
                    : {
                        itemsPerPage: isMobile ? 4 : isTablet ? 6 : 8,
                        currentPage: currentPage
                      }
              "
            >
              <p>
                {{
                  currentLang == ApplicationLanguages.Ar
                    ? store.titleAr
                    : store.titleEn
                }}
              </p>
              <img
                loading="lazy"
                [src]="'/assets/images/online/' + store.image"
                [alt]="
                  currentLang == ApplicationLanguages.Ar
                    ? store.titleAr
                    : store.titleEn
                "
                *ngIf="store.image"
              />
              <a *ngIf="store.url" target="_blank" [href]="store.url">{{
                "explore" | translate
              }}</a>
            </li>
          </ul>

          <div class="pagination-controls-container">
            <pagination-controls
              (pageChange)="currentPage = $event"
              (pageBoundsCorrection)="currentPage = $event"
              [maxSize]="isMobile ? 5 : 9"
              [autoHide]="true"
              [responsive]="false"
              previousLabel=""
              nextLabel=""
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
